<div class="dashboard-container">
  <div class="logo-section">
    <img src="assets/logo-sistema.png" alt="Logo PDV System" class="logo" />
  </div>

  <div class="welcome-section">
    <h1>Bem-vindo ao PDV</h1>
    <p class="user-greeting" *ngIf="currentUser">
      Olá, <strong>{{ currentUser.sub }}</strong>!
    </p>
    <p class="description">
      Sistema de Ponto de Venda - Gerencie suas operações com eficiência
    </p>
  </div>

  <div class="quick-access">
    <h2>Acesso Rápido</h2>
    <div class="quick-links">
      <a routerLink="/produtos" class="quick-link-card">
        <i class="fas fa-boxes"></i>
        <span>Produtos</span>
      </a>
      <a routerLink="/clientes" class="quick-link-card">
        <i class="fas fa-users"></i>
        <span>Clientes</span>
      </a>
      <a routerLink="/venda" class="quick-link-card">
        <i class="fas fa-cash-register"></i>
        <span>Nova Venda</span>
      </a>
      <a routerLink="/estoque" class="quick-link-card">
        <i class="fas fa-warehouse"></i>
        <span>Estoque</span>
      </a>
    </div>
  </div>
</div>
